module.exports = __webpack_public_path__ + "img/sv5.8d38bd60.svg";